import React from "react";

const Footer = () => {
  return (
    <div id="footer">
      <p>
        <a
          href="https://github.com/T1LT/CryptoPred"
          target="_blank"
          rel="noopener noreferrer"
        >
          Github Repository
        </a>
      </p>
      <br />
      <br />
      <p>
        * The predictions displayed here are not 100% accurate, please invest
        wisely.
      </p>
    </div>
  );
};

export default Footer;
